module.exports = __webpack_public_path__ + "static/photo_10-2ad8ba20d9a9221a5d3e6bb3f34bc7e9.jpg";